export const EMAIL_REGEX = /^(")?(?:[^."])(?:(?:[.])?(?:[\w\-!#$%&'*+/=?^_`{|}~]))*\1@(\w[-\w]*\.){1,5}([A-Za-z]){2,6}$/;
export const USERNAME_REGEX = /^[a-zA-Z0-9_-]{6,16}$/;
export const CHARACTER_EMAIL_REGEX = /[a-z]/i;
export const SPECIAL_CHARACTER_EMAIL_REGEX = /^(([^<>()[].,;:s@"]+(.[^<>()[].,;:s@"]+)*)|(".+"))@(([^<>()[].,;:s@"]+.)+[^<>()[].,;:s@"]{2,})$/i;
export const URL = /^(https?:\/\/)?((([a-z\d]([a-z\d-]*[a-z\d])*)\.?)+[a-z]{2,}|((\d{1,3}\.){3}\d{1,3}))(:\d+)?(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(#[-a-z\d_]*)?$/i;
export const NUMERIC_REGEX = /[^0-9]/g;
export const ALPHA_NUMERIC_REGEX = /[^a-zA-Z0-9]/g;
export const LICENSE_NUMBER_REGEX = /[^A-Za-z0-9-\d_ ]/g;
export const LIMIT_TEN_CHARACTERS = /^[A-Za-z0-9-\d_ ]{1,10}$/;



// WEBPACK FOOTER //
// ./src/utils/regex.js